import React from "react";
import PropTypes from "prop-types";
import Text from "react-svg-text";
import { COLOR_CLUE, BOX_SIZE } from "../../../../constants";
import CellBackground from "../CellBackground";

const Clue = ({ x, y, cell }) => {
  const padding = 5;
  const dx = x * BOX_SIZE;
  const dy = y * BOX_SIZE;

  const data = "horizontal" in cell ? cell.horizontal : cell.vertical;

  const clue = data.image ? (
    <image
      x={dx + padding}
      y={dy + padding}
      width={BOX_SIZE - padding * 2}
      height={BOX_SIZE - padding * 2}
      xlinkHref={`/${data.image}`}
      preserveAspectRatio="xMidYMid meet"
    />
  ) : (
    <Text
      x={dx + BOX_SIZE / 2}
      y={dy + BOX_SIZE / 2}
      width={BOX_SIZE - padding * 2}
      height={BOX_SIZE - padding * 2}
      fontSize="12"
      textAnchor="middle"
      verticalAnchor="middle"
    >
      {data.text}
    </Text>
  );

  return (
    <g data-x={x} data-y={y}>
      <CellBackground x={dx} y={dy} color={COLOR_CLUE} />
      {clue}
    </g>
  );
};

Clue.defaultProps = {
  x: 0,
  y: 0,
  cell: {}
};

const dataType = PropTypes.shape({
  text: PropTypes.string,
  image: PropTypes.string
});

Clue.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  cell: PropTypes.shape({
    horizontal: dataType,
    vertical: dataType
  })
};

export default Clue;



// WEBPACK FOOTER //
// ./src/components/Cells/Cells/Clue/Clue.js